module.exports = __webpack_public_path__ + "img/CV.Utilities.Chambers.Precast_concrete_chambers.781c45d4.png";